import { useElements, useStripe } from "@stripe/react-stripe-js"
import { clearLocalStorage } from "../stores/local_storage"
import { State, StripeToken, Total } from "../types"
import { FormSubmission } from "../utils/FormSubmission"
import { FormSubmitDisplay } from "./display"
import { useNavigate } from "react-router-dom"
import { useContext } from "react"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import { createStripeConfirmationToken } from "../queries"
import { RetryableDonationFormInvariantError } from "../errors"

type FormSubmitProps = {
  state: State
  totalCents: Total
}

export function FormSubmit({ state, totalCents }: FormSubmitProps) {
  const {
    current_person: {
      data: {
        attributes: {
          name: currentPersonName,
          email_address: currentPersonEmail,
        },
      },
    },
    current_organization: { id: currentOrganizationId },
  } = useContext(ServerRenderedProps)
  const navigate = useNavigate()
  const stripe = useStripe()
  const stripeElements = useElements()

  const obtainStripeToken = async (): Promise<StripeToken> => {
    if (!stripe || !stripeElements) {
      throw new RetryableDonationFormInvariantError()
    } else if (state.stripePaymentMethod?.id) {
      return state.stripePaymentMethod.id
    } else {
      const stripeConfirmationToken = await createStripeConfirmationToken({
        stripe,
        stripeElements,
        billingName: currentPersonName,
        billingEmail: currentPersonEmail,
        organizationId: currentOrganizationId,
      })
      return stripeConfirmationToken.id
    }
  }

  const handleSubmit = async () => {
    try {
      const stripeToken = await obtainStripeToken()
      const submission = FormSubmission.create({
        state,
        stripeToken,
      })
      await submission.submit()
      clearLocalStorage()
      navigate("donation_thank_you")
    } catch (error) {
      alert(`Error: ${error}`)
    }
  }

  return <FormSubmitDisplay {...{ handleSubmit, totalCents }} />
}
